export default __webpack_public_path__ + "static/media/grey-thin.58b2edd6.webp";